export const PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS = {
  PRIMARY_INSURANCE_POLICY_CARRIER: "Patient.PrimaryInsurancePolicy.Carrier",
  PRIMARY_INSURANCE_POLICY_MEMBER_ID: "Patient.PrimaryInsurancePolicy.MemberID",
  PRIMARY_INSURANCE_POLICY_GROUP_NUMBER:
    "Patient.PrimaryInsurancePolicy.GroupNumber",
  PRIMARY_INSURANCE_POLICY_PLAN: "Patient.PrimaryInsurancePolicy.Plan",
  PRIMARY_INSURANCE_POLICY_COMPANY_CONTACT_NUMBER:
    "Patient.PrimaryInsurancePolicy.CompanyContactNumber",
  PRIMARY_INSURANCE_POLICY_NOTES: "Patient.PrimaryInsurancePolicy.Notes",
  //
  PRIMARY_INSURANCE_POLICY_HOLDER_RELATION_TO_ISSUER:
    "Patient.PrimaryInsurancePolicy.Holder.RelationToInsurer",
  PRIMARY_INSURANCE_POLICY_HOLDER_FIRST_NAME:
    "Patient.PrimaryInsurancePolicy.Holder.FirstName",
  PRIMARY_INSURANCE_POLICY_HOLDER_LAST_NAME:
    "Patient.PrimaryInsurancePolicy.Holder.LastName",
  PRIMARY_INSURANCE_POLICY_HOLDER_FULL_NAME:
    "Patient.PrimaryInsurancePolicy.Holder.FullName",
  PRIMARY_INSURANCE_POLICY_HOLDER_MIDDLE_INITIAL:
    "Patient.PrimaryInsurancePolicy.Holder.MiddleInitial",
  PRIMARY_INSURANCE_POLICY_HOLDER_SEX:
    "Patient.PrimaryInsurancePolicy.Holder.Sex",
  PRIMARY_INSURANCE_POLICY_HOLDER_DATE_OF_BIRTH:
    "Patient.PrimaryInsurancePolicy.Holder.DateOfBirth",
  PRIMARY_INSURANCE_POLICY_HOLDER_EMPLOYER_NAME:
    "Patient.PrimaryInsurancePolicy.Holder.EmployerName",
  PRIMARY_INSURANCE_POLICY_HOLDER_FULL_ADDRESS:
    "Patient.PrimaryInsurancePolicy.Holder.FullAddress",
  PRIMARY_INSURANCE_POLICY_HOLDER_ADDRESS_LINE1:
    "Patient.PrimaryInsurancePolicy.Holder.AddressLine1",
  PRIMARY_INSURANCE_POLICY_HOLDER_ADDRESS_LINE2:
    "Patient.PrimaryInsurancePolicy.Holder.AddressLine2",
  PRIMARY_INSURANCE_POLICY_HOLDER_CITY:
    "Patient.PrimaryInsurancePolicy.Holder.City",
  PRIMARY_INSURANCE_POLICY_HOLDER_STATE:
    "Patient.PrimaryInsurancePolicy.Holder.State",
  PRIMARY_INSURANCE_POLICY_HOLDER_ZIP_CODE:
    "Patient.PrimaryInsurancePolicy.Holder.ZIPCode",
  PRIMARY_INSURANCE_POLICY_HOLDER_PHONE_NUMBER:
    "Patient.PrimaryInsurancePolicy.Holder.PhoneNumber",
  //
  PRIMARY_INSURANCE_POLICY_BENEFITS_HEARING_AID_BENEFIT:
    "Patient.PrimaryInsurancePolicy.Benefits.HearingAidBenefit",
  PRIMARY_INSURANCE_POLICY_BENEFITS_DEDUCTIBLE:
    "Patient.PrimaryInsurancePolicy.Benefits.Deductible",
  PRIMARY_INSURANCE_POLICY_COPAY: "Patient.PrimaryInsurancePolicy.CoPay"
};

export const PATIENT_PRIMARY_INSURANCE_POLICY_MENU_OPTIONS = {
  title: "Patient - Primary Insurance Policy",
  menu: [
    {
      title: "Policy Details",
      menu: [
        {
          title: "Patient - Primary Insurance Policy - Carrier",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_CARRIER
        },
        {
          title: "Patient - Primary Insurance Policy - Member ID",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_MEMBER_ID
        },
        {
          title: "Patient - Primary Insurance Policy - Group Number",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_GROUP_NUMBER
        },
        {
          title: "Patient - Primary Insurance Policy - Plan/Program Name",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_PLAN
        },
        {
          title: "Patient - Primary Insurance Policy - Company Contact Number",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_COMPANY_CONTACT_NUMBER
        },
        {
          title: "Patient - Primary Insurance Policy - Notes",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_NOTES
        }
      ]
    },
    {
      title: "Policy Holder Details",
      menu: [
        {
          title:
            "Patient - Primary Insurance Policy - Holder Relation to Insurer",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_HOLDER_RELATION_TO_ISSUER
        },
        {
          title: "Patient - Primary Insurance Policy - Holder First Name",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_HOLDER_FIRST_NAME
        },
        {
          title: "Patient - Primary Insurance Policy - Holder Last Name",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_HOLDER_LAST_NAME
        },
        {
          title: "Patient - Primary Insurance Policy - Holder Full Name",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_HOLDER_FULL_NAME
        },
        {
          title: "Patient - Primary Insurance Policy - Holder Middle Initial",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_HOLDER_MIDDLE_INITIAL
        },
        {
          title: "Patient - Primary Insurance Policy - Holder Sex",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_HOLDER_SEX
        },
        {
          title: "Patient - Primary Insurance Policy - Holder Date of Birth",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_HOLDER_DATE_OF_BIRTH
        },
        {
          title: "Patient - Primary Insurance Policy - Holder Employer Name",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_HOLDER_EMPLOYER_NAME
        },
        {
          title: "Patient - Primary Insurance Policy - Holder Full Address",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_HOLDER_FULL_ADDRESS
        },
        {
          title: "Patient - Primary Insurance Policy - Holder Address Line 1",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_HOLDER_ADDRESS_LINE1
        },
        {
          title: "Patient - Primary Insurance Policy - Holder Address Line 2",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_HOLDER_ADDRESS_LINE2
        },
        {
          title: "Patient - Primary Insurance Policy - Holder City",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_HOLDER_CITY
        },
        {
          title: "Patient - Primary Insurance Policy - Holder State",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_HOLDER_STATE
        },
        {
          title: "Patient - Primary Insurance Policy - Holder ZIP Code",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_HOLDER_ZIP_CODE
        },
        {
          title: "Patient - Primary Insurance Policy - Holder Phone Number",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_HOLDER_PHONE_NUMBER
        }
      ]
    },
    {
      title: "Policy Benefits",
      menu: [
        {
          title: "Patient - Primary Insurance Policy - Hearing Aid Benefit",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_BENEFITS_HEARING_AID_BENEFIT
        },
        {
          title: "Patient - Primary Insurance Policy - Deductible",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_BENEFITS_DEDUCTIBLE
        },
        {
          title: "Patient - Primary Insurance Policy - Co-pay",
          value:
            PATIENT_PRIMARY_INSURANCE_POLICY_OPTIONS.PRIMARY_INSURANCE_POLICY_COPAY
        }
      ]
    }
  ]
};
